module.exports = __webpack_public_path__ + "img/icon-continuar-leyendo-2.f2f113ea.png";